var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright"},[_c('div',[_vm._v("智联云油提供技术支持")]),_c('div',{on:{"click":_vm.know}},[_c('Tag',[_vm._v(" 了解更多 "),_c('icon',{attrs:{"name":"arrow"}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }